<kz-card
  [ngClass]="{'reversed': reversed}"
  fullWidth="true">
  <div class="kz-card--pro-header">
    <div>
      <div class="kz-card--pro-header-infos">
          <span class="kz-card--pro-header-infos-profilpicture">
            <div *kzImgPlaceholder="false;showProfile:true;"></div>
          </span>
        <div>
          <div style="display: flex; align-items: center; max-width: 80%;">
            <kz-text-placeholder nbLines="1" biggerFirstLine="true"></kz-text-placeholder>
            <span kzBadge badgeType="pro" [badgePlaceholder]="'shimmer'" style="margin-left: 1rem"></span>
          </div>
          <kz-text-placeholder nbLines="2" biggerFirstLine="false"></kz-text-placeholder>
          <div class="kz-card--pro-header-tags">
            <span kzTag tagPlaceholder="shimmer" *appTimes="3"></span>
          </div>
        </div>
      </div>
      <p class="kz-card--pro-header-description">
        <kz-text-placeholder [nbLines]="2"></kz-text-placeholder>
      </p>
    </div>
    <div class="kz-annuaire--footer">
      <div class="kz-card--pro-cta"></div>
      <span kzButton buttonContext="secondary" buttonPlaceholder="shimmer"></span>
    </div>
  </div>
  <div class="kz-card--pro-media kz-card--pro-media--empty">
    <div *kzImgPlaceholder="false;showLogo:true;"></div>
  </div>
</kz-card>
